/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import React from 'react';
import { Route } from 'react-router';

import ErrorBoundaryRoutes from 'app/shared/error/error-boundary-routes';

import Language from './language';
import LanguageDetail from './language-detail';
import LanguageUpdate from './language-update';
import LanguageDeleteDialog from './language-delete-dialog';

const LanguageRoutes = () => (
  <ErrorBoundaryRoutes>
    <Route index element={<Language />} />
    <Route path="new" element={<LanguageUpdate />} />
    <Route path=":id">
      <Route index element={<LanguageDetail />} />
      <Route path="edit" element={<LanguageUpdate />} />
      <Route path="delete" element={<LanguageDeleteDialog />} />
    </Route>
  </ErrorBoundaryRoutes>
);

export default LanguageRoutes;
